import React, { FC } from 'react';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import { ISubmitSuffixProps } from './interfaces';

const SubmitSuffix: FC<ISubmitSuffixProps> = ({ onSubmit }) => (
  <Tooltip placement="bottom" title="Сохранить">
    <Button onClick={onSubmit}>
      <CheckCircleOutlined translate="yes" />
    </Button>
  </Tooltip>
);

export default SubmitSuffix;
